// @flow

export const machines = (state: StoreType): any => state.machine.machines;
export const serverStatuses = (state: StoreType): any => state.machine.serverStatuses;
export const nasServerStatuses = (state: StoreType): any => state.machine.nasServerStatuses;
export const cameraServerStatuses = (state: StoreType): any => state.machine.cameraServerStatuses;
export const networkSwitchServerStatuses = (state: StoreType): any => state.machine.networkSwitchServerStatuses;
export const serverWorkStationServerStatuses = (state: StoreType): any => state.machine.serverWorkStationServerStatuses;
export const noOfRequest = (state: StoreType): any => state.machine.noOfRequest;
export const allLogs = (state: StoreType): any => state.machine.logs;
export const alertLogs = (state: StoreType): any => state.machine.alertLogs;
export const billingDetails = (state: StoreType): any => state.machine.billingDetails;
export const auctionDetails = (state: StoreType): any => state.machine.auctionDetails;
export const cardDetails = (state: StoreType): any => state.machine.cardDetails;
export const reports = (state: StoreType): any => state.machine.reports;
export const cardSwapLogs = (state: StoreType): any => state.machine.cardSwapLogs;
export const stats = (state: StoreType): any => {
  if (!state || !state.machine || !state.machine.stats) {
    return {
      totalVehicleInsideToday: 0,
      totalVehicleEnteredToday: 0,
      totalVehicleExitedToday: 0,
      totalMaterialDispatchedToday: 0,
      totalMaterialPriceDispatchedToday: 0,
      totalMaterialDispatchedYesterday: 0,
      totalMaterialPriceDispatchedYesterday: 0,
      totalMaterialDispatchedCurrentMonth: 0,
      totalMaterialPriceDispatchedCurrentMonth: 0,
      totalMaterialDispatchedLastMonth: 0,
      totalMaterialPriceDispatchedLastMonth: 0,
      totalMaterialDispatchedCurrentYear: 0,
      totalMaterialPriceDispatchedCurrentYear: 0,
      totalMaterialDispatchedLastYear: 0,
      totalMaterialPriceDispatchedLastYear: 0,
      timeSeries: {
        dates: [],
        totalWeight: [],
        totalPrice: [],
      },
    };
  }

  return state.machine.stats;
};
